<!-- @format -->

<div class="overview-container">
	<div class="overview-container-menu">
		<div>
			<div class="heading">
				<p>{{ unitName }}</p>

				<button
					class="close-button"
					[routerLink]="['/home']"
					[state]="[firstRender, selectedValues]"
					(click)="closeOverview()">
					Close
				</button>
			</div>
			<p class="instructions">Select a form from the list below</p>

			<div class="search-bar">
				<img
					class="search-icon"
					src="../assets/search-alt.svg"
					alt="search" />
					<input
						type="text"
						placeholder="Search Form name"
						[ngModel]="searchText"
						(ngModelChange)="onSearchTextChange($event)" />
			</div>
		</div>

		<div class="logsheet-labels">
			<a
				[routerLink]="[
					'/home',
					'overview',
					'branch',
					logsheet.logSheetTemplateId
				]"
					routerLinkActive="active-link"
					queryParamsHandling="preserve"
				[state]="[logsheet.logSheetName]"
				class="logsheet-label"
				*ngFor="
					let logsheet of logsheets
						| search : searchText : 'logSheetName'
				">
				{{ logsheet.logSheetName }}
			</a>
		</div>
	</div>
	<div class="overview-container-main">
		<div class="custom-section" [class.card]="!isFormRoute">
			<router-outlet></router-outlet>
		</div>
	</div>
</div>
